var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.48177C5.8025 5.17927 8.87333 5.02344 11.935 5.02344C13.75 5.02344 15.565 5.1151 17.38 5.29844L19.25 5.48177",
    stroke: "#ED484B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2085 4.55575L14.0068 3.35492C13.8602 2.48409 13.7502 1.83325 12.201 1.83325H9.79933C8.25016 1.83325 8.131 2.52075 7.9935 3.36409L7.79183 4.55575",
    stroke: "#ED484B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72096 8.37842L5.3168 17.6092C5.41763 19.0484 5.50013 20.1667 8.05763 20.1667H13.9426C16.5001 20.1667 16.5826 19.0484 16.6835 17.6092L17.2793 8.37842",
    stroke: "#ED484B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5308 15.125H9.47826",
    stroke: "#ED484B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2915 11.4583H8.70817",
    stroke: "#ED484B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDelete);
export default __webpack_public_path__ + "static/media/menu-delete.b37bab28ca5c0e87d75510e1ea1a76db.svg";
export { ForwardRef as ReactComponent };